import { DraggableMenu } from '@shared/components/Menu/DraggableMenu';
import type { AntdMenuItem } from '@shared/types/menu';

interface SidebarMenuProps {
  menuItems: AntdMenuItem[];
  selectedKeys: string[];
  openKeys: string[];
  onOpenChange: (keys: string[]) => void;
  onClick: (e: { key: string }) => void;
  inlineCollapsed: boolean;
  isDark: boolean;
}

/**
 * Компонент меню сайдбара
 */
export function SidebarMenu({
  menuItems,
  selectedKeys,
  openKeys,
  onOpenChange,
  onClick,
  inlineCollapsed,
  isDark,
}: SidebarMenuProps) {
  return (
    <DraggableMenu
      items={menuItems}
      selectedKeys={selectedKeys}
      openKeys={openKeys}
      onOpenChange={onOpenChange}
      onClick={onClick}
      theme={isDark ? 'dark' : 'light'}
      mode="inline"
      inlineCollapsed={inlineCollapsed}
    />
  );
}

